module.exports = __webpack_public_path__ + "static/media/icashrewards.dc733358.png";